import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'page-header-search',
  templateUrl: './page-header-search.component.html',
  styleUrls: ['./page-header-search.component.scss']
})
export class PageHeaderSearchComponent implements OnInit, OnChanges {
  @Input() isSearchInput;
  @Input() pageTitleValue;
  @Input() placeholderValue;
  @Output() onHeaderInputKeyup = new EventEmitter<string>();
  @Output() onHeaderSearchSubmit = new EventEmitter<string>();

  @Input() searchString: string = '';
  searchedValue: string = '';

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.searchedValue = changes?.searchString?.currentValue ?? '';
  }

  ngOnInit(): void {
  }

  onInputKeyup() {
    if(!this.searchString.trim() && (this.searchedValue.trim() != this.searchString.trim())){
      this.onSearchSubmit();
    }
    this.onHeaderInputKeyup.emit(this.searchString);
  }

  onSearchSubmit() {
    if(this.searchString.trim() != this.searchedValue.trim()){
      this.searchedValue = this.searchString.trim();
      this.onHeaderSearchSubmit.emit(this.searchString);
    }
  }
}
